import { render, staticRenderFns } from "./DirectService.vue?vue&type=template&id=72b5802c&scoped=true"
import script from "./DirectService.vue?vue&type=script&lang=js"
export * from "./DirectService.vue?vue&type=script&lang=js"
import style0 from "./DirectService.vue?vue&type=style&index=0&id=72b5802c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5802c",
  null
  
)

export default component.exports